import * as ss from 'superstruct';

export const ConversionSource = ss.enums([
  /** Website conversions. */
  'website',
  /** In platform Meta leads. */
  'meta',
  /** In platform Linked In leads. */
  'linkedin',
  /** Google leads. */
  'google',
  /** Generic import. */
  'import',
  /** Phone call conversions (Dialpad, Twilio, etc.). */
  'phone-call',
  /** CRM-origin conversions (Leap, etc.). */
  'crm',
]);

export type ConversionSource = ss.Infer<typeof ConversionSource>;
